<template>
  <table class="receiptTable caption" cellspacing="0">
    <tr>
      <th colspan="7" class="title py-4">
        {{ settleData.settleTitle }}
      </th>
    </tr>
    <tr>
      <th width="15%">客户名称</th>
      <th>年份</th>
      <th>月份</th>
      <th>当月总收益（含税13%）</th>
      <th>甲方分成比例</th>
      <th>甲方当月收益（不含税）</th>
      <th>甲方当月收益（含税合计）</th>
    </tr>
    <tr>
      <td class="text-center" style="width: 10%;">{{ settleData.agency?.name }}</td>
      <td class="text-center">{{ new Date(settleData.settleList[0]?.date).getFullYear() }}年</td>
      <td class="text-center">{{ new Date(settleData.settleList[0]?.date).getMonth() + 1 }}月</td>
      <td class="text-center">{{ project_income_total | formatMoney }}</td>
      <td class="text-center">{{ Number(settleData.settleList[0]?.agency_ratio?.$numberDecimal).toFixed(2) }}%</td>
      <td class="text-center">{{ agency_service_fee_no_tax_total | formatMoney }}</td>
      <td class="text-center">{{ agency_fee_total | formatMoney }}</td>
    </tr>
    <tr style="border: 1px solid #000; border-top: 0; border-bottom: 0;">
      <td colspan="2" class="text-left no-border font-weight-bold pl-6" style="vertical-align: top;">制表人：{{ settleData.producedBy?.personal?.name }}</td>
      <td colspan="2" class="text-left no-border font-weight-bold pl-6">
        <template v-if="comfirmors.length">
          <v-row v-for="(item, i) in comfirmors" :key="i">
            <v-col cols="6" align="right" class="pr-0">
              <span v-if="i === 0">确认人：</span>
            </v-col>
            <v-col cols="6" align="left" class="pl-0">
              {{ item }}
            </v-col>
          </v-row>
        </template>
        <template v-else>
          确认人：
        </template>
      </td>
      <td colspan="2" class="text-left no-border font-weight-bold pl-6" style="vertical-align: top;">
        <template v-if="approvers.length">
          <v-row v-for="(item, i) in approvers" :key="i">
            <v-col cols="6" align="right" class="pr-0">
              <span v-if="i === 0">核定人：</span>
            </v-col>
            <v-col cols="6" align="left" class="pl-0">
              {{ item }}
            </v-col>
          </v-row>
        </template>
        <template v-else>
          核定人：
        </template>
      </td>
      <td colspan="2" class="text-left no-border font-weight-bold pl-6" style="vertical-align: top;">
        <template v-if="reviewers.length">
          <v-row v-for="(item, i) in reviewers" :key="i">
            <v-col cols="6" align="right" class="pr-0">
              <span v-if="i === 0">复核人：</span>
            </v-col>
            <v-col cols="6" align="left" class="pl-0">
              {{ item }}
            </v-col>
          </v-row>
        </template>
        <template v-else>
          复核人：
        </template>
      </td>
    </tr>
    <tbody style="border: 1px solid #000;">
    <tr>
      <td colspan="3" class="text-center no-border">甲方：{{ settleData.agency?.name }}</td>
      <td colspan="4" class="text-center no-border">乙方：北京鑫泰能源股份有限公司</td>
    </tr>
    <tr>
      <td colspan="3" class="text-center no-border" v-if="this.reviewTime">日期：{{ reviewTime.getFullYear() + '年' + (reviewTime.getMonth()+1)+ '月' + reviewTime.getDate() + '日' }}</td>
      <td colspan="3" class="text-center no-border" v-else>日期：<span style="letter-spacing: 1.5rem;" class="pl-10">年月日</span></td>
      <td colspan="4" class="text-center no-border" v-if="this.reviewTime">日期：{{ reviewTime.getFullYear() + '年' + (reviewTime.getMonth()+1)+ '月' + reviewTime.getDate() + '日' }}</td>
      <td colspan="4" class="text-center no-border" v-else>日期：<span style="letter-spacing: 1.5rem;" class="pl-10">年月日</span></td>
    </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      comfirmors: [],
      approvers: [],
      reviewers: [],
      project_income_total: 0,
      agency_fee_total: 0,
      agency_service_fee_no_tax_total: 0,
      reviewTime: '',
    }
  },
  props: {
    getType: {
      type: Number,
      require: true,
      default: null,
    },
    getId: {
      type: String,
      require: true,
      default: '',
    },
    settleData: {
      type: Object,
      default: null,
    },
    color: {
      type: String,
      default: "primary"
    },
    divider: {
      type: String,
      default: null
    }
  },
  watch: {
    settleData() {
      this.checkData()
    },
  },
  created() {
    this.checkData()
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    checkData() {
      this.resetData()
      this.settleData.settleList.map(item => {
        this.project_income_total += Number(item.project_income?.$numberDecimal)
        this.agency_service_fee_no_tax_total += Number(item.agency_service_fee_no_tax?.$numberDecimal)
        this.agency_fee_total += Number(item.agency_fee?.$numberDecimal)
      })
      this.settleData.tasks_list.map((item, i) => {
        item.record?.map((op,j) => {
          if (op.action === 1) {
            if (i === 0) this.comfirmors.push(op.operator.personal.name)
            if (i === 1) this.approvers.push(op.operator.personal.name)
            if (i === 2) {
              if (j === 0) this.reviewTime = new Date(op.optime)
              this.reviewers.push(op.operator.personal.name)
            }
          }
        })
      })
      this.comfirmors = [...new Set(this.comfirmors)]
      this.approvers = [...new Set(this.approvers)]
      this.reviewers = [...new Set(this.reviewers)]
    },
    resetData() {
      this.dialog = false
      this.comfirmors = []
      this.approvers = []
      this.reviewers = []
      this.agency_service_fee_no_tax_total = 0
      this.agency_fee_total = 0
      this.project_income_total = 0
      this.year = ''
      this.month = []
      this.minMonth = ''
      this.maxMonth = ''
    },
    downloadReceipt() {
      console.log('download')
    },
  },
  directives: {}
}
</script>

<style scoped>
.receiptTable {
  width: 1px;
  min-width: 100%;
  border-collapse: collapse;
}
.receiptTable td,
.receiptTable th {
  padding: 0 4px;
  height: 30px;
  border: 1px solid rgb(0, 0, 0);
  color: #000 !important;
}
.receiptTable td.no-border {
  border: 0;
  padding: 20px 4px;
}
.receiptTable>tr>th+th {
  border-left-width: 0;
}
.receiptTable>tr+tr>th {
  border-top-width: 0;
}
.receiptTable>tr>td+td {
  border-left-width: 0;
}
.receiptTable>tr+tr>td {
  border-top-width: 0;
}
</style>
